import {Deal, BasketTotalWithBreakDown, BasketItem} from "@irati/types/ops"
import totals, {tallyTotals, TotalsData, getProductAndVAT, totalsForItem} from "./totals"

const baseZipRate = 2.8

export default function totalsWithZipRate(items: BasketItem[], data: TotalsData): BasketTotalWithBreakDown {
  const totalBeforeZip = totals(items, data)

  totalBeforeZip.items!.forEach((basketItem) => {
    const {product, productVAT, entity} = getProductAndVAT(basketItem.item!, data)
    basketItem.total = totalsForItem(basketItem.item!, product, productVAT)
    const newPrice = addRate(entity, basketItem!.total!.amount!)
    basketItem!.total!.serviceCharge = newPrice - basketItem!.total!.amount!
  })

  return {
    ...totalBeforeZip,
    cashback: {amount: 0},
    total: tallyTotals(totalBeforeZip.items!)
  }
}

function addRate(deal: Deal, amount: number) {
  const rate = parseFloat(`${deal.paymentOptions?.zip?.rate || baseZipRate}`)
  // reverse percentage calculation so we get the required total
  return Math.round((amount * 100) / (100 - rate))
}
